module.exports = __webpack_public_path__ + "img/quarterly.e0d2568a.png";